











import {Component, Vue} from 'vue-property-decorator';

import TrackingOrdersChartFiltration from '@/screens/dashboard/charts/TrackingOrdersChartFiltration.vue';
import OrdersChartFiltration from '@/screens/dashboard/charts/OrdersChartFiltration.vue';


@Component({
  components: {TrackingOrdersChartFiltration, OrdersChartFiltration}

})
export default class Overview extends Vue {
}
